import React, { useEffect } from 'react';
import './workordermodal.css'; // Importing the CSS for styling
import WorkOrder from './workorder';

const WorkOrderModal = ({ showModal, toggleModal, workOrder, onWorkOrderUpdated }) => {
  // Add/remove class to App when modal opens/closes
  useEffect(() => {
    const appElement = document.querySelector('.App');
    if (showModal) {
      appElement?.classList.add('workorder-open');
    } else {
      appElement?.classList.remove('workorder-open');
    }
    
    // Cleanup on unmount
    return () => {
      appElement?.classList.remove('workorder-open');
    };
  }, [showModal]);

  if (!showModal) {
    return null;
  }

  const handleWorkOrderUpdate = (updatedWorkOrder) => {
    console.log('=== WORK ORDER MODAL - handleWorkOrderUpdate ===');
    console.log('Updated work order:', updatedWorkOrder);
    
    if (onWorkOrderUpdated && updatedWorkOrder) {
      onWorkOrderUpdated(updatedWorkOrder);
    }
    toggleModal();
  };

  return (
    <div className="workordermodal-overlay">
      <div className="workordermodal-content">
        {workOrder && <WorkOrder workOrder={workOrder} onClose={handleWorkOrderUpdate} />}
      </div>
    </div>
  );
};

export default WorkOrderModal;
